import { Card, CardContent, Typography, Grid, TextField } from "@mui/material";

const DetailsCard = ({ title, details }) => {
  return (
    <>
        <Grid container spacing={2}>
          {Object.entries(details)
            .filter(([key,value]) => key !== "company_id" && key !== "company_esi_id" && value !== "" && value !== null && value !== undefined)
            .map(([key, value]) => (
            <Grid item xs={6} sm={6} key={key}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{
                  color: "#636363",
                  fontSize: "12px",
                }}
              >
                {key.replace(/_/g, " ").toUpperCase()}
              </Typography>
              <TextField
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                }}
                fullWidth
                margin="dense"
                size="small"
                value={value}
                disabled
              />
            </Grid>
          ))}
        </Grid>
    </>
  );
};

export default DetailsCard;
